import { faDna, faFlask, faBacteria, faTooth, faHeart, faBrain, faMobile, faDroplet } from '@fortawesome/free-solid-svg-icons';
import WBT1 from './Platforms/WBT/WBT1/wbt1';
import WBTAbout from './Platforms/WBT/WBTAbout';

export const platformsConfig = [
  {
    id: 'wbt-atlas',
    name: 'Whole Blood Transcriptome Atlas',
    shortName: 'WHOLE BLOOD TRANSCRIPTOME (WBT) ATLAS',
    category: 'Transcriptomics',
    description: 'Comprehensive analysis of gene expression patterns in whole blood samples ',
    icon: faDna,
    features: [
      'Population-scale transcriptomic analysis',
      'Disease-specific expression profiles',
      'Interactive expression heatmaps',
      'Cross-cohort comparison tools'
    ],
    stats: {
      Samples: '2000+',
      Genes: '20,000+',
      Health_Conditions: '27+',
      Physiological_Systems: '12'
    },
    status: 'live',
    launchDate: '2024',
    link: '/atlas/wbt-atlas',
    platformType: 'wbt',
    searchPlaceholder: 'Search genes, pathways, diseases...',
    component: WBT1,
    aboutComponent: WBTAbout
  },













  
  {
    id: 'proteome-atlas',
    name: 'Human Proteome Atlas',
    shortName: 'PLASMA PROTEOME ATLAS',
    category: 'Proteomics',
    description: 'Large-scale protein expression and modification analysis across tissues.',
    icon: faFlask,
    features: [
      'Tissue-specific protein mapping',
      'Post-translational modification analysis',
      'Protein-protein interaction networks',
      'Disease-associated protein changes',
      'AI protein structure prediction'
    ],
    stats: {
      Samples: '2,000+',

      Proteins: '9,000+',

      
      tissues: '44',
      cells: '200+',
      modifications: '10,000+'
    },
    status: 'coming-soon',
    launchDate: '2024 Q4',
    platformType: 'proteome',
    searchPlaceholder: 'Search proteins, tissues, modifications...',
    component: null,
    aboutComponent: null
  },




  {
    id: 'metabolome-atlas',
    name: 'Metabolome Atlas',
    shortName: 'PLASMA METABOLOME ATLAS',
    category: 'Metabolomics',
    description: 'Global metabolite profiling and pathway analysis across biological systems.',
    icon: faHeart,
    features: [
      'Untargeted metabolomics profiling',
      'Pathway enrichment analysis',
      'Metabolite identification tools',
      'Biomarker discovery pipeline',
      'Cross-omics integration'
    ],
    stats: {
      Samples: '2,000+',

      Features: '1,500+',

      samples: '25,000+',
      studies: '100+'
    },
    status: 'development',
    launchDate: '2025 Q1',
    platformType: 'metabolome',
    searchPlaceholder: 'Search metabolites, pathways, compounds...',
    component: null,
    aboutComponent: null
  },

   {
    id: 'lipidome',
    name: 'Lipidome Atlas',
    shortName: 'PLASMA LIPIDOME ATLAS',
    category: 'Metabolomics',
    description: 'Comprehensive analysis of gene expression patterns in whole blood samples.',
    icon: faDroplet,
    features: [
      'Population-scale transcriptomic analysis',
      'Disease-specific expression profiles',
      'Interactive expression heatmaps',
      'Cross-cohort comparison tools'
    ],
    stats: {
      Samples: '2,000+',

      Features: '500+',

      Health_Conditions: '27+',
      Physiological_Systems: '12'
    },
    status: 'coming-soon',
    launchDate: '2024',
    link: '/atlas/wbt-atlas',
    platformType: 'wbt',
    searchPlaceholder: 'Search genes, pathways, diseases...',
    component: WBT1,
    aboutComponent: WBTAbout
  },
    {
    id: 'genomics-atlas',
    name: 'Genome Atlas',
    shortName: 'WHOLE GENOME ATLAS',
    category: 'Genomics',
    description: 'Comprehensive genomic variant analysis and interpretation across populations and diseases.',
    icon: faBrain,
    features: [
      'Whole genome sequencing analysis',
      'Variant calling and annotation',
      'Population genetics studies',
      'Disease association mapping',
      'Pharmacogenomics profiling'
    ],
    stats: {
      Samples: '10,000+',

      Variants: '500M+',
      Populations: '50+',
      Diseases: '1000+'
    },
    status: 'development',
    launchDate: '2025 Q3',
    platformType: 'genomics',
    searchPlaceholder: 'Search variants, genes, populations...',
    component: null,
    aboutComponent: null
  },
    {
    id: 'oral-health-atlas',
    name: 'Oral Health Atlas',
    shortName: 'ORAL METAGENOME ATLAS',
    category: 'Metagenomics',
    description: 'Comprehensive atlas of the oral microbiome, metabolites and biomarkers.',
    icon: faTooth,
    features: [
      'Salivary microbiome profiling',
      'Dental plaque analysis',
      'Biomarker detection',
      'Oral metabolite mapping',
      'Oral health risk estimation'
    ],
    stats: {
      Samples: '8,000+',

      Species: '100+',
      regions: '300K+',
      datasets: '200+'
    },
    status: 'development',
    launchDate: '2025 Q2',
    platformType: 'oral-health',
    searchPlaceholder: 'Search oral microbes, biomarkers...',
    component: null,
    aboutComponent: null
  },

  {
    id: 'gut-health-atlas',
    name: 'Gut Health Atlas',
    shortName: 'GUT METAGENOME ATLAS',
    category: 'Metagenomics',
    description: 'Microbiome composition, metabolite profiling and more data for gut health.',
    icon: faBacteria,
    features: [
      'Microbiome sequencing',
      'Metabolite analysis',
      'Host transcriptome integration',
      'Diet correlation analysis',
      'Gut health scoring'
    ],
    stats: {
      marks: '40+',
      species: '80+',
      regions: '500K+',
      datasets: '300+'
    },
    status: 'development',
    launchDate: '2025 Q2',
    platformType: 'gut-health',
    searchPlaceholder: 'Search microbes, metabolites, genes...',
    component: null,
    aboutComponent: null
  },
  



    {
    id: 'urine-m',
    name: 'Whole Blood Transcriptome Atlas',
    shortName: 'URINE METABOLOME ATLAS',
    category: 'Metabolomics',
    description: 'Comprehensive analysis of gene expression patterns in whole blood samples.',
    icon: faDroplet,
    features: [
      'Population-scale transcriptomic analysis',
      'Disease-specific expression profiles',
      'Interactive expression heatmaps',
      'Cross-cohort comparison tools'
    ],
    stats: {
      Samples: '2000+',
      Genes: '20,000+',
      Health_Conditions: '27+',
      Physiological_Systems: '12'
    },
    status: 'coming-soon',
    launchDate: '2024',
    link: '/atlas/wbt-atlas',
    platformType: 'wbt',
    searchPlaceholder: 'Search genes, pathways, diseases...',
    component: WBT1,
    aboutComponent: WBTAbout
  },
   

];